/**
 * @description Use this on a file input to extract the text contents of a file
 * @example
 * <input type="file" cs-get-file-content="myCtrl.model.fileContent" />
 */
;(function () {
  angular
    .module('contrast.files')
    .directive('csGetFileContent', function (FileReader) {
      'ngInject'
      return {
        scope: {
          csGetFileContent: '='
        },
        link: function ($scope, el) {
          el.on('change', function (e) {
            var file = e.target.files[0]
            var read = new FileReader()
            read.onloadend = function () {
              $scope.$apply(function () {
                $scope.csGetFileContent = read.result
              })
            }
            read.readAsText(file)
            el.val(null)
          })
        }
      }
    })
})()
